(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
(() => {
  const bars = document.querySelectorAll('[data-announcement-rotator]');
  bars.forEach((bar) => {
    const messages = [...bar.querySelectorAll('.announcement__message')];
    if (!messages.length) return;
    let index = 0;
    messages[0].classList.add('is-active');
    if (messages.length > 1) {
      window.setInterval(() => {
        messages[index].classList.remove('is-active');
        index = (index + 1) % messages.length;
        messages[index].classList.add('is-active');
      }, 5000);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aruba-colour-selection"] && !Shopify.designMode) return;
  try {
    
  const initialiseArubaColourCarousels = (scope = document) => {
    scope.querySelectorAll('[data-aruba-colour-carousel]').forEach((carousel) => {
      if (carousel.dataset.carouselReady === 'true') return;

      const track = carousel.querySelector('[data-carousel-track]');
      const progress = carousel.querySelector('[data-carousel-progress]');
      const firstSlide = track?.querySelector('.featured-products__slide');

      if (!track || !progress || !firstSlide) return;

      carousel.dataset.carouselReady = 'true';

      const updateControls = () => {
        const maximumScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        progress.value = maximumScroll > 0 ? (track.scrollLeft / maximumScroll) * 100 : 0;
        carousel.classList.toggle('is-not-scrollable', maximumScroll <= 1);
      };

      progress.addEventListener('input', () => {
        const maximumScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        track.scrollLeft = maximumScroll * (Number(progress.value) / 100);
      });

      carousel.querySelector('[data-og-prev]').addEventListener('click',()=>track.scrollBy({left:-(firstSlide.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap)),behavior:'smooth'}));
      carousel.querySelector('[data-og-next]').addEventListener('click',()=>track.scrollBy({left:firstSlide.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap),behavior:'smooth'}));
      let scrollFrame;
      track.addEventListener('scroll', () => {
        window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(updateControls);
      }, { passive: true });

      if ('ResizeObserver' in window) {
        new ResizeObserver(updateControls).observe(track);
      } else {
        window.addEventListener('resize', updateControls);
      }

      updateControls();
    });
  };

  initialiseArubaColourCarousels();
  document.addEventListener('shopify:section:load', (event) => {
    initialiseArubaColourCarousels(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aruba-cord-campaign"] && !Shopify.designMode) return;
  try {
    
function initializeCordCampaign(){document.querySelectorAll('.cs-cord-campaign').forEach(section=>{if(section.dataset.initialized)return;section.dataset.initialized='true';const mq=matchMedia('(max-width:749px)'),button=section.querySelector('.cs-cord-campaign__pause'),videos=[...section.querySelectorAll('video')];let userPaused=false;const active=()=>section.querySelector(mq.matches?'.cs-cord-campaign__media--mobile video':'.cs-cord-campaign__media--desktop video');const sync=()=>{const video=active();button.hidden=!video;if(video){button.setAttribute('aria-label',video.paused?'Play campaign video':'Pause campaign video');button.firstElementChild.textContent=video.paused?'▷':'Ⅱ';}};const update=()=>{videos.forEach(video=>{video.muted=true;video.playsInline=true;video.controls=false;if(video===active()&&!userPaused)video.play().catch(()=>{});else video.pause();});sync();};videos.forEach(video=>{video.addEventListener('play',sync);video.addEventListener('pause',sync);video.addEventListener('loadeddata',update);});button.addEventListener('click',()=>{const video=active();if(!video)return;userPaused=!video.paused;update();});mq.addEventListener('change',update);update();});}
initializeCordCampaign();document.addEventListener('shopify:section:load',initializeCordCampaign);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-list-editorial"] && !Shopify.designMode) return;
  try {
    

function initializeCollectionPeeks(scope=document){
scope.querySelectorAll('.collection-peek').forEach(peek=>{
if(peek.dataset.ready)return;peek.dataset.ready='true';
let gestureStartX=0,gestureStartY=0,gestureStartScroll=0,gestureMoved=false;
peek.addEventListener('pointerdown',event=>{gestureStartX=event.clientX;gestureStartY=event.clientY;gestureStartScroll=peek.scrollLeft;gestureMoved=false;});
peek.addEventListener('pointermove',event=>{if(Math.abs(event.clientX-gestureStartX)>8||Math.abs(event.clientY-gestureStartY)>8)gestureMoved=true;});
peek.addEventListener('click',event=>{if(event.detail!==0&&(gestureMoved||Math.abs(peek.scrollLeft-gestureStartScroll)>8))event.preventDefault();});
peek.querySelectorAll('img').forEach(image=>image.draggable=false);
const shell=peek.closest('.collection-peek-shell'),count=shell.querySelector('.collection-peek__count'),prev=shell.querySelector('[data-peek-prev]'),next=shell.querySelector('[data-peek-next]'),total=1+peek.querySelectorAll('.collection-peek__mobile-item').length;
const step=()=>peek.firstElementChild.getBoundingClientRect().width+(parseFloat(getComputedStyle(peek).gap)||0);
const update=()=>{peek.classList.toggle('is-peek-scrolled',peek.scrollLeft>8);const index=Math.round(peek.scrollLeft/step());count.textContent=(index+1)+' / '+total;prev.disabled=index===0;next.disabled=index===total-1;};
prev.addEventListener('click',()=>peek.scrollBy({left:-step(),behavior:'smooth'}));
next.addEventListener('click',()=>peek.scrollBy({left:step(),behavior:'smooth'}));
peek.addEventListener('scroll',update,{passive:true});update();
});
}
initializeCollectionPeeks();document.addEventListener('shopify:section:load',e=>initializeCollectionPeeks(e.target));
function initializeBeyondRows(scope=document){scope.querySelectorAll('[data-beyond-track]').forEach(track=>{if(track.dataset.rowReady)return;track.dataset.rowReady='true';const section=track.closest('.collection-list'),prev=section.querySelector('[data-beyond-prev]'),next=section.querySelector('[data-beyond-next]');if(!prev||!next||!track.firstElementChild)return;const update=()=>{prev.disabled=track.scrollLeft<=1;next.disabled=track.scrollLeft>=track.scrollWidth-track.clientWidth-2;};const move=direction=>track.scrollBy({left:direction*(track.firstElementChild.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap||0)),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));track.addEventListener('scroll',update,{passive:true});if('ResizeObserver' in window)new ResizeObserver(update).observe(track);update();});}
initializeBeyondRows();document.addEventListener('shopify:section:load',event=>initializeBeyondRows(event.target));

function initializeCollectionPictureGestures(scope=document){
 scope.querySelectorAll('.collection-peek').forEach(peek=>{
  if(peek.dataset.pictureGesture)return;peek.dataset.pictureGesture='true';
  let active=false,startX=0,startScroll=0,moved=false;
  const fine=()=>matchMedia('(hover:hover) and (pointer:fine)').matches;
  peek.addEventListener('pointerdown',event=>{moved=false;if(event.pointerType!=='mouse'||event.button!==0)return;active=true;startX=event.clientX;startScroll=peek.scrollLeft;});
  peek.addEventListener('pointermove',event=>{if(!active)return;const delta=event.clientX-startX;if(Math.abs(delta)>6){moved=true;peek.classList.add('is-dragging');peek.setPointerCapture(event.pointerId);peek.scrollLeft=startScroll-delta;event.preventDefault();}});
  const finish=event=>{if(!active)return;active=false;peek.classList.remove('is-dragging');if(peek.hasPointerCapture(event.pointerId))peek.releasePointerCapture(event.pointerId);if(moved){const step=peek.firstElementChild.getBoundingClientRect().width+(parseFloat(getComputedStyle(peek).gap)||0);peek.scrollTo({left:Math.round(peek.scrollLeft/step)*step,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});}};
  peek.addEventListener('pointerup',finish);peek.addEventListener('pointercancel',finish);
  peek.addEventListener('click',event=>{if(moved){event.preventDefault();event.stopImmediatePropagation();}},{capture:true});
 });
}
initializeCollectionPictureGestures();document.addEventListener('shopify:section:load',event=>initializeCollectionPictureGestures(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  const initialiseFeaturedProductCarousels = (scope = document) => {
    scope.querySelectorAll('[data-featured-products-carousel]').forEach((carousel) => {
      if (carousel.dataset.carouselReady === 'true') return;

      const track = carousel.querySelector('[data-carousel-track]');
      const progress = carousel.querySelector('[data-carousel-progress]');
      const firstSlide = track?.querySelector('.featured-products__slide');

      if (!track || !progress || !firstSlide) return;

      carousel.dataset.carouselReady = 'true';

      const updateControls = () => {
        const maximumScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        progress.value = maximumScroll > 0 ? (track.scrollLeft / maximumScroll) * 100 : 0;
        carousel.classList.toggle('is-not-scrollable', maximumScroll <= 1);
      };

      progress.addEventListener('input', () => {
        const maximumScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        track.scrollLeft = maximumScroll * (Number(progress.value) / 100);
      });

      let scrollFrame;
      track.addEventListener('scroll', () => {
        window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(updateControls);
      }, { passive: true });

      if ('ResizeObserver' in window) {
        new ResizeObserver(updateControls).observe(track);
      } else {
        window.addEventListener('resize', updateControls);
      }

      updateControls();
    });
  };

  initialiseFeaturedProductCarousels();
  document.addEventListener('shopify:section:load', (event) => {
    initialiseFeaturedProductCarousels(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
function initializeConceptFooter(){
  document.querySelectorAll('#FooterNewsletterForm').forEach(form => {
    if (form.dataset.preferencesInitialized) return;
    form.dataset.preferencesInitialized = 'true';
    const preferences = form.querySelector('[data-newsletter-preferences]');
    const tags = form.querySelector('[data-newsletter-tags]');
    const submit = form.querySelector('.site-footer__submit');
    const actions = form.querySelector('[data-newsletter-step-actions]');
    if (!preferences || !tags || !submit || !actions) return;
    const syncTags = () => {
      tags.value = ['newsletter', ...Array.from(form.querySelectorAll('[data-newsletter-interest]:checked'), input => input.value)].join(',');
    };
    form.addEventListener('change', syncTags);
    form.addEventListener('submit', event => {
      syncTags();
      if (form.dataset.signupStep !== 'email') return;
      event.preventDefault();
      form.dataset.signupStep = 'preferences';
      preferences.hidden = false;
      actions.hidden = false;
      submit.hidden = true;
      preferences.querySelector('input').focus();
    });
    form.querySelector('[data-newsletter-skip]').addEventListener('click', () => {
      form.querySelectorAll('[data-newsletter-interest]').forEach(input => { input.checked = false; });
      syncTags();
    });
    form.dataset.signupStep = 'email';
    preferences.hidden = true;
    submit.setAttribute('aria-label', 'Continue signing up');
    syncTags();
  });
  document.querySelectorAll('.site-footer__navigation').forEach(group=>{
    if(group.dataset.initialized) return;
    group.dataset.initialized='true';
    let desktop;
    const sync=()=>{
      const next=group.closest('.site-footer').getBoundingClientRect().width>=750;
      if(next===desktop) return;
      desktop=next;
      group.querySelectorAll('details').forEach(item=>{item.open=desktop;item.querySelector('summary').tabIndex=desktop?-1:0;});
    };
    sync();
    new ResizeObserver(sync).observe(group.closest('.site-footer-container'));
  });
}
initializeConceptFooter();
document.addEventListener('shopify:section:load',initializeConceptFooter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-has-a-shape"] && !Shopify.designMode) return;
  try {
    

function initializeHeroTiles(){
 document.querySelectorAll('.cs-two-tile-hero').forEach(hero=>{
  if(hero.dataset.initialized)return;hero.dataset.initialized='true';
  const tiles=[...hero.querySelectorAll('.cs-two-tile-hero__tile-wrap')],mobile=matchMedia('(max-width:749px)'),reduced=matchMedia('(prefers-reduced-motion:reduce)'),toggle=hero.querySelector('.cs-hero-toggle'),bars=[...hero.querySelectorAll('[data-slide]')];
  let index=0,elapsed=0,last=performance.now(),paused=reduced.matches,touchX=0,touchY=0,suppressClick=false;
  const activeVideo=tile=>tile.querySelector(mobile.matches?'.cs-two-tile-hero__media--mobile video':'.cs-two-tile-hero__media--desktop video');
  const syncVideos=()=>tiles.forEach((tile,i)=>{
   const active=activeVideo(tile),visible=!mobile.matches||i===index,button=tile.querySelector('.cs-two-tile-hero__pause');
   tile.querySelectorAll('video').forEach(video=>{if(video!==active||!visible||(mobile.matches&&paused))video.pause();else if(!tile.dataset.videoPaused)video.play().catch(()=>{});});
   button.hidden=!active;if(active){button.setAttribute('aria-label',active.paused?'Play video':'Pause video');button.innerHTML=active.paused?'<span aria-hidden="true">▷</span>':'<svg viewBox="0 0 24 24" width="12" height="12" aria-hidden="true"><path d="M8 5v14M16 5v14" stroke="currentColor" stroke-width="1.5" fill="none"/></svg>';} 
  });
  const render=()=>{
   tiles.forEach((tile,i)=>{tile.classList.toggle('is-active',i===index);tile.classList.toggle('is-before',i<index);tile.inert=mobile.matches&&i!==index;tile.setAttribute('aria-hidden',String(mobile.matches&&i!==index));});
   bars.forEach((bar,i)=>{bar.setAttribute('aria-current',String(i===index));bar.style.setProperty('--progress',(i<index?100:i===index?elapsed/6000*100:0)+'%');});
   toggle.setAttribute('aria-label',paused?'Play campaign rotation':'Pause campaign rotation');toggle.firstElementChild.textContent=paused?'▷':'Ⅱ';
  };
  const go=i=>{index=(i+tiles.length)%tiles.length;elapsed=0;render();syncVideos();};
  hero.addEventListener('transitionend',event=>{if(event.propertyName==='transform')syncVideos();});
  window.addEventListener('pageshow',syncVideos);
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)syncVideos();});
  document.addEventListener('touchend',syncVideos,{passive:true});
  hero.querySelector('.cs-hero-next').addEventListener('click',()=>go(index+1));
  bars.forEach((bar,i)=>bar.addEventListener('click',()=>go(i)));
  toggle.addEventListener('click',()=>{paused=!paused;render();syncVideos();});
  tiles.forEach(tile=>{
   tile.querySelectorAll('video').forEach(video=>{video.defaultMuted=true;video.muted=true;video.playsInline=true;video.controls=false;video.addEventListener('loadeddata',syncVideos);video.addEventListener('canplay',syncVideos);video.addEventListener('play',()=>{const button=tile.querySelector('.cs-two-tile-hero__pause');button.setAttribute('aria-label','Pause video');button.innerHTML='<svg viewBox="0 0 24 24" width="12" height="12" aria-hidden="true"><path d="M8 5v14M16 5v14" stroke="currentColor" stroke-width="1.5" fill="none"/></svg>';});video.addEventListener('pause',()=>{const button=tile.querySelector('.cs-two-tile-hero__pause');button.setAttribute('aria-label','Play video');button.innerHTML='<span aria-hidden="true">▷</span>';});});
   tile.querySelector('.cs-two-tile-hero__pause').addEventListener('click',()=>{const video=activeVideo(tile);if(!video)return;tile.dataset.videoPaused=video.paused?'':'true';if(video.paused)video.play().catch(()=>{});else video.pause();});
  });
  hero.addEventListener('touchstart',event=>{touchX=event.changedTouches[0].clientX;touchY=event.changedTouches[0].clientY;},{passive:true});
  hero.addEventListener('touchend',event=>{const dx=event.changedTouches[0].clientX-touchX,dy=event.changedTouches[0].clientY-touchY;if(mobile.matches&&Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)){suppressClick=true;go(index+(dx<0?1:-1));setTimeout(()=>suppressClick=false,400);}},{passive:true});
  hero.addEventListener('click',event=>{if(suppressClick&&event.target.closest('a')){event.preventDefault();event.stopPropagation();}},true);
  mobile.addEventListener('change',()=>{render();syncVideos();});
  const observer=new IntersectionObserver(entries=>{hero.dataset.inView=entries[0].isIntersecting?'true':'false';if(entries[0].isIntersecting)syncVideos();});observer.observe(hero);
  const tick=now=>{const delta=Math.min(now-last,100);last=now;if(mobile.matches&&!paused&&!document.hidden&&hero.dataset.inView!=='false'&&!hero.contains(document.activeElement)){elapsed+=delta;if(elapsed>=6000)go(index+1);render();}if(hero.isConnected)requestAnimationFrame(tick);else observer.disconnect();};
  render();syncVideos();requestAnimationFrame(tick);
 });
}
initializeHeroTiles();document.addEventListener('shopify:section:load',initializeHeroTiles);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["island-navigation"] && !Shopify.designMode) return;
  try {
    
function initializeIslandBrowser(scope=document){
scope.querySelectorAll('.island-browser').forEach(browser=>{
if(browser.dataset.ready)return;
browser.dataset.ready='true';
const track=browser.querySelector('.islands-media'),prev=browser.querySelector('[data-island-prev]'),next=browser.querySelector('[data-island-next]');
if(!track||!prev||!next)return;
const update=()=>{prev.disabled=track.scrollLeft<=1;next.disabled=track.scrollLeft>=track.scrollWidth-track.clientWidth-2;};
const move=direction=>{const width=track.querySelector('.island-panel').getBoundingClientRect().width;track.scrollBy({left:direction*(width+parseFloat(getComputedStyle(track).gap||0)),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});};
prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
track.addEventListener('scroll',update,{passive:true});
if('ResizeObserver' in window)new ResizeObserver(update).observe(track);
update();
});
}
initializeIslandBrowser();document.addEventListener('shopify:section:load',event=>initializeIslandBrowser(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-concept"]) return;
  try {
    
document.querySelectorAll('.concept-collection__pagination a').forEach(link=>{const url=new URL(link.href,location.origin);url.searchParams.set('view','concept');link.href=url.toString()});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-contact"]) return;
  try {
    
function initializeConceptContact(){
  document.querySelectorAll('[data-concept-contact]').forEach(root=>{
    if(root.dataset.initialized) return;
    root.dataset.initialized='true';
    const form=root.querySelector('form');
    const key='concept-contact-draft';
    if(root.querySelector('[data-contact-success]')){
      try{sessionStorage.removeItem(key);}catch{}
      return;
    }
    const message=form.querySelector('[name="contact[body]"]');
    const orderNumber=form.querySelector('[name="contact[Order number]"]');
    const radios=form.querySelectorAll('[name="contact[Is this about an order?]"]');
    const counter=root.querySelector('#ContactCounter');
    const syncOrder=()=>{
      const yes=root.querySelector('#ContactOrderYes').checked;
      orderNumber.disabled=!yes;
      root.querySelector('#ContactOrderNumberField').hidden=!yes;
    };
    const syncCounter=()=>{
      if(message.value.length>500) message.value=message.value.slice(0,500);
      counter.textContent=message.value.length+'/500';
    };
    try{
      const saved=JSON.parse(sessionStorage.getItem(key)||'null');
      if(saved&&Date.now()-saved.time<1800000&&root.querySelector('[data-contact-errors]')){
        for(const [name,value] of Object.entries(saved.fields)){
          const field=Array.from(form.elements).find(item=>item.name===name&&item.type!=='radio');
          if(field) field.value=value;
        }
        radios.forEach(radio=>{radio.checked=radio.value===saved.order;});
      }
    }catch{}
    syncOrder();
    syncCounter();
    radios.forEach(radio=>radio.addEventListener('change',syncOrder));
    message.addEventListener('input',syncCounter);
    form.addEventListener('submit',()=>{
      syncOrder();
      syncCounter();
      const fields={};
      ['contact[name]','contact[email]','contact[body]','contact[Order number]'].forEach(name=>{
        const field=Array.from(form.elements).find(item=>item.name===name);
        if(field&&!field.disabled) fields[name]=field.value;
      });
      try{sessionStorage.setItem(key,JSON.stringify({time:Date.now(),fields,order:root.querySelector('#ContactOrderYes').checked?'Yes':'No'}));}catch{}
    });
  });
}
initializeConceptContact();
document.addEventListener('shopify:section:load',initializeConceptContact);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-gifting"]) return;
  try {
    
function initializeGiftingForms(){
document.querySelectorAll('[data-gifting]').forEach(root=>{
if(root.dataset.initialized)return;
root.dataset.initialized='true';
const form=root.querySelector('form');
if(!form)return;
const storageKey='cs-gifting-enquiry-draft';
if(root.querySelector('[data-gifting-success]')){try{sessionStorage.removeItem(storageKey);}catch{}return;}
const message=form.querySelector('[data-word-limit]');
const counter=root.querySelector('#GiftingCounter');
if(!message||!counter)return;
const countWords=value=>value.trim()?value.trim().split(/\s+/u).length:0;
const update=()=>{
const count=countWords(message.value);
const over=count>600;
counter.textContent=counter.dataset.counterTemplate.replace('[count]',String(count));
counter.dataset.overLimit=String(over);
message.setCustomValidity(over?message.dataset.limitMessage:'');
message.setAttribute('aria-invalid',String(over));
return !over;
};
try{
if(root.querySelector('[data-gifting-errors]')){
const saved=JSON.parse(sessionStorage.getItem(storageKey)||'null');
if(saved&&Date.now()-saved.time<1800000){
for(const field of form.elements){if(field.name?.startsWith('contact[')&&field.type!=='hidden'&&Object.hasOwn(saved.fields,field.name))field.value=saved.fields[field.name];}
}
}
}catch{}
message.addEventListener('input',update);
form.addEventListener('submit',event=>{
if(!update()){event.preventDefault();message.reportValidity();return;}
const fields={};
for(const field of form.elements){if(field.name?.startsWith('contact[')&&field.type!=='hidden')fields[field.name]=field.value;}
try{sessionStorage.setItem(storageKey,JSON.stringify({time:Date.now(),fields}));}catch{}
});
update();
});
}
initializeGiftingForms();
document.addEventListener('shopify:section:load',initializeGiftingForms);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
function initializeCordShadeCircles(scope=document){
 scope.querySelectorAll('.cord-shade-circles--picker').forEach(group=>{
  if(group.dataset.ready)return;group.dataset.ready='true';
  const root=group.closest('.main-product'),select=root?.querySelector('[data-option-dropdown][data-option-index="'+group.dataset.shadeIndex+'"]');
  if(!select)return;
  const sync=()=>group.querySelectorAll('[data-cord-shade]').forEach(button=>{
   const option=[...select.options].find(option=>option.value===button.dataset.cordShade);
   button.setAttribute('aria-pressed',String(select.value===button.dataset.cordShade));
   button.disabled=!option;
   button.title=option?.textContent||button.dataset.cordShade;
  });
  group.addEventListener('click',event=>{const button=event.target.closest('[data-cord-shade]');if(!button||button.disabled)return;select.value=button.dataset.cordShade;
   let variants=[];try{variants=JSON.parse(root.querySelector('[data-cs-variants]').textContent);}catch(error){}
   const selects=[...root.querySelectorAll('[data-option-dropdown]')],index=Number(group.dataset.shadeIndex);
   const compatible=variants.some(variant=>variant.options[index]===select.value&&selects.every(other=>!other.value||other===select||variant.options[Number(other.dataset.optionIndex)]===other.value));
   if(!compatible)selects.forEach(other=>{if(other!==select)other.value='';});
   select.dispatchEvent(new Event('change',{bubbles:true}));sync();});
  root.addEventListener('change',sync);sync();
 });
}
initializeCordShadeCircles();document.addEventListener('shopify:section:load',event=>initializeCordShadeCircles(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["og-favorites"] && !Shopify.designMode) return;
  try {
    
  const initialiseOgFavoriteCarousels = (scope = document) => {
    scope.querySelectorAll('[data-og-favorites-carousel]').forEach((carousel) => {
      if (carousel.dataset.carouselReady === 'true') return;

      const track = carousel.querySelector('[data-carousel-track]');
      const progress = carousel.querySelector('[data-carousel-progress]');
      const firstSlide = track?.querySelector('.featured-products__slide');

      if (!track || !progress || !firstSlide) return;

      carousel.dataset.carouselReady = 'true';

      const updateControls = () => {
        const maximumScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        progress.value = maximumScroll > 0 ? (track.scrollLeft / maximumScroll) * 100 : 0;
        carousel.classList.toggle('is-not-scrollable', maximumScroll <= 1);
      };

      progress.addEventListener('input', () => {
        const maximumScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        track.scrollLeft = maximumScroll * (Number(progress.value) / 100);
      });

      carousel.querySelector('[data-og-prev]').addEventListener('click',()=>track.scrollBy({left:-(firstSlide.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap)),behavior:'smooth'}));
      carousel.querySelector('[data-og-next]').addEventListener('click',()=>track.scrollBy({left:firstSlide.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap),behavior:'smooth'}));
      let scrollFrame;
      track.addEventListener('scroll', () => {
        window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(updateControls);
      }, { passive: true });

      if ('ResizeObserver' in window) {
        new ResizeObserver(updateControls).observe(track);
      } else {
        window.addEventListener('resize', updateControls);
      }

      updateControls();
    });
  };

  initialiseOgFavoriteCarousels();
  document.addEventListener('shopify:section:load', (event) => {
    initialiseOgFavoriteCarousels(event.target);
  });

function initializeMobileCardSwipes(scope=document){
 const mobile=()=>matchMedia('(max-width:749px), (max-width:989px) and (pointer:coarse)').matches;
 scope.querySelectorAll('body.template-index .featured-products .product-card,body.template-index .collection-list__card').forEach(card=>{
  if(card.dataset.mobileSwipeReady)return;card.dataset.mobileSwipeReady='true';
  let startX=0,startY=0,active=false,moved=false,held=false,holdTimer,restoreSecond=false;
  const media=card.querySelector('[data-card-track]');
  const finishHold=()=>{clearTimeout(holdTimer);active=false;if(held&&media)media.classList.toggle('is-thumbnail-second',restoreSecond);};
  card.addEventListener('pointerdown',event=>{
   if(!mobile()||event.button!==0)return;
   clearTimeout(holdTimer);active=true;moved=false;held=false;startX=event.clientX;startY=event.clientY;
   if(media&&media.contains(event.target)&&media.querySelectorAll('.product-card__slide').length>1){
    restoreSecond=media.classList.contains('is-thumbnail-second');
    holdTimer=setTimeout(()=>{if(active&&!moved){held=true;media.classList.add('is-thumbnail-second');}},300);
   }
  },{passive:true});
  card.addEventListener('pointermove',event=>{if(active&&(Math.abs(event.clientX-startX)>8||Math.abs(event.clientY-startY)>8)){moved=true;finishHold();}},{passive:true});
  card.addEventListener('pointerup',finishHold,{passive:true});
  card.addEventListener('pointerleave',finishHold,{passive:true});
  card.addEventListener('pointercancel',()=>{finishHold();moved=true;},{passive:true});
  card.addEventListener('contextmenu',event=>{if(mobile()&&held)event.preventDefault();});
  card.addEventListener('click',event=>{if(mobile()&&(moved||held)&&event.detail!==0){event.preventDefault();event.stopImmediatePropagation();}},{capture:true});
  card.querySelectorAll('img').forEach(image=>image.draggable=false);
 });
}
initializeMobileCardSwipes();document.addEventListener('shopify:section:load',event=>initializeMobileCardSwipes(event.target));
function initializeMobilePhotoThumbnails(scope=document){
 scope.querySelectorAll('body.template-index .featured-products .product-card').forEach(card=>{
  if(card.dataset.photoThumbnailsReady)return;
  const media=card.querySelector('[data-card-track]'),slides=media?[...media.querySelectorAll('.product-card__slide')].slice(0,2):[];
  if(slides.length<2||slides.some(slide=>!slide.querySelector('img')))return;
  card.dataset.photoThumbnailsReady='true';
  const controls=document.createElement('div');controls.className='mobile-card-photo-thumbnails';controls.setAttribute('role','group');controls.setAttribute('aria-label','Product photographs');
  slides.forEach((slide,index)=>{
   const original=slide.querySelector('img'),button=document.createElement('button'),image=original.cloneNode();
   button.type='button';button.setAttribute('aria-label','View photograph '+(index+1));button.setAttribute('aria-pressed',String(index===0));image.removeAttribute('id');image.alt='';image.loading='lazy';image.sizes='40px';image.draggable=false;
   button.append(image);button.addEventListener('click',event=>{
    event.preventDefault();event.stopPropagation();media.classList.toggle('is-thumbnail-second',index===1);
    controls.querySelectorAll('button').forEach((control,i)=>control.setAttribute('aria-pressed',String(i===index)));
   });controls.append(button);
  });
  card.querySelector('.product-card__carousel').after(controls);
 });
}
initializeMobilePhotoThumbnails();document.addEventListener('shopify:section:load',event=>initializeMobilePhotoThumbnails(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["work-with-rugeen"]) return;
  try {
    
function setupRugeenForm(){const form=document.getElementById('RugeenWorkForm');if(!form||form.dataset.wordCounterReady)return;const brief=form.querySelector('#RuBrief'),counter=form.querySelector('#RuWordCount');if(!brief||!counter)return;form.dataset.wordCounterReady='true';function update(){const count=brief.value.trim()?brief.value.trim().split(/\s+/u).length:0;const over=count>499;brief.setCustomValidity(over?brief.dataset.limitMessage:'');brief.setAttribute('aria-invalid',String(over));counter.textContent=brief.dataset.counterTemplate.replace('[count]',String(count));counter.classList.toggle('is-over',over)}brief.addEventListener('input',update);form.addEventListener('submit',event=>{update();if(!form.checkValidity()){event.preventDefault();form.reportValidity()}});update()}
setupRugeenForm();document.addEventListener('shopify:section:load',setupRugeenForm);

  } catch(e) { console.error(e); }
})();
})();
